/**
 * Constants for Business Units Table
 */

import { DEFAULT_DATE_RANGE_DAYS } from './DashboardFiltersDefinitions';

// Default values
export const DEFAULT_VALUES = {
	SELECTED_PERIOD: DEFAULT_DATE_RANGE_DAYS
};

// Table configuration
export const TABLE_CONFIG = {
	TABLE_ID: 'business-units-table',
	KEY_FIELD: 'id',
	DATA_TYPE: 'Business Unit'
};
